(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  function featured_collection() {
    /* ================ Product slider JS Start ================ */
    var productSlider = new Swiper(".product-slider", {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      loopAdditionalSlides: 30,
      breakpoints: {
        601: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    /* ================ Product slider JS End ================ */
  }
  
  $(document).on('shopify:section:load shopify:section:unload shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    featured_collection();
  });

  $(document).ready(function(e){
    featured_collection();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-style-1"] && !Shopify.designMode) return;
  try {
    
  function marquee_slider_1() {
    /* ================ Natural murquee slider JS End ================ */
    var naturalMurquee = new Swiper(".natural-murquee", {
      spaceBetween: 30,
      speed: 6000,
      autoplay: {
        delay: 0,
      },
      loop: true,
      slidesPerView: "auto",
      draggable: false,
      disableOnInteraction: true,
      allowTouchMove: false,
      breakpoints: {
        601: {
          spaceBetween: 60,
        },
        768: {
          spaceBetween: 100,
        },
      },
    });
    /* ================ Natural murquee slider JS End ================ */
  }
  
  $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    marquee_slider_1();
  });

  $(document).ready(function(e){
    marquee_slider_1();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-style-2"] && !Shopify.designMode) return;
  try {
    
  function marquee_slider_2() {
    /* ================ Murquee slider JS End ================ */
    var murqueeSlider = new Swiper(".murquee-slider", {
      spaceBetween: 0,
      speed: 8000,
      autoplay: {
        delay: 0,
      },
      loop: true,
      slidesPerView: "auto",
      disableOnInteraction: true,
      allowTouchMove: false,
    });
    /* ================ Murquee slider JS End ================ */
  }
  
  $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    marquee_slider_2();
  });

  $(document).ready(function(e){
    marquee_slider_2();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  window.relatedProducts = function() {
    /* ================ Product slider JS Start ================ */
    var productSlider = new Swiper(".product-slider", {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      loopAdditionalSlides: 30,
      breakpoints: {
        601: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
    /* ================ Product slider JS End ================ */
  }
  
  $(document).on('shopify:section:load shopify:section:unload shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    window.relatedProducts();
  });

  $(document).ready(function(e){
    window.relatedProducts();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonial"] && !Shopify.designMode) return;
  try {
    
  function video_testimonial() {
    /* ================ Customer slider section JS Start ================ */
    var customerSlider = new Swiper(".customer-slider", {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 10,
      loopAdditionalSlides: 30,
      pagination: {
        el: ".customer-slider .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        601: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        991: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        1180: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      },
    });
    /* ================ Customer slider section JS End ================ */
  }

  $(document).on('shopify:section:load shopify:section:unload shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    video_testimonial();
  });

  $(document).ready(function(e){
    video_testimonial();

    /* ================ Customer video popup JS Start ================ */
    $("body").on("click", ".customer-items", function () {
      let videoLink = $(this).data("video-url");
      $(".customer-video-popup, .menu-wrapper").addClass("open");
      $("body").addClass("overflow-hidden");
      $('.video-popup-main video source').attr("src", videoLink)
      $(".video-popup-main video")[0].load()
      $(".video-popup-main video")[0].play();
    });
    $("body").on("click", ".video-popup-close", function () {
      $(".customer-video-popup, .menu-wrapper").removeClass("open");
      $("body").removeClass("overflow-hidden");
      $(".video-popup-main video")[0].pause();
    });
    /* ================ Customer video popup JS End ================ */
  });

  } catch(e) { console.error(e); }
})();
})();
